import styled from "styled-components";

export const TextButton = styled.button`
  font-size: 12px;
  color: #72bbff;
  display: block;
  cursor: pointer;
`;
